import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import { Small } from '@components/Text'

export const Form = styled.form`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 100px;
  background-color: transparent;
  box-sizing: border-box;
  margin-top: 32px;
  margin-bottom: 8px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 496px;
    background-color: #ffffff;
    padding: 8px;
    max-width: none;
    margin: 0;
  }
`

export const Input = styled.input`
  border-radius: 100px;
  border: none;
  margin-bottom: 12px;
  padding: 0 24px;
  width: 100%;
  height: 64px;

  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 0;
    padding: 0 10px;
    flex-grow: 1;
    outline: none;
    width: 0;
    height: auto;
  }
`

export const FormAction = styled.section`
  width: 100%;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 176px;
  }
`

export const ErrorMessage = styled(Small)`
  width: 100%;
  margin-top: 8px;
  color: var(--error);
`
